export default __webpack_public_path__ + "static/media/sales.4d7b97ea.svg";